import React, { useEffect, useState } from "react";
import {
    Box,
    Paper,
    Button,
    IconButton,
    FormControlLabel,
    Checkbox,
    Radio
} from "@mui/material";
import { Delete, ModeEdit } from "@mui/icons-material";

const ImageSelector = ({ id, typeName, order, input: { onChange }, fieldState, options, multiple, ...props }) => {
    const [images, setImages] = useState([]);
    const [hidden, setHidden] = useState(false);

    const handleImageUpload = (event) => {
        const files = event.target.files;
        if (files) {
            const newImages = Array.from(files).map((file) => ({
                id: `${file.name}-${Date.now()}`,
                name: file.name,
                url: URL.createObjectURL(file),
            }));
            setImages((prevImages) => [...prevImages, ...newImages]);
        }
    };

    const handleRemoveImage = (imageId) => {
        setImages((prevImages) => prevImages.filter((image) => image.id !== imageId));
    };

    const handleSelectionChange = (image) => {
        if (onChange) {
            let result = fieldState?.result || [];

            if (multiple) {
                const isAlreadySelected = result.some((img) => img.value === image.name);

                if (isAlreadySelected) {
                    result = result.filter((img) => img.value !== image.name);
                } else {
                    // Add the image to the result if it's not already in
                    const newImage = options
                        .filter((img) => img.value === image.name)
                        .map((img) => ({ ...img, default: true }));

                    result = [...result, ...newImage];
                }
            } else {
                // Single selection: only the current image is included in the result
                result = options
                    .filter((img) => img.value === image.name)
                    .map((img) => ({ ...img, default: true }));
            }

            // Trigger the onChange callback with updated result
            onChange({ id, typeName, order, result });
        }
    };


    const convertOptions = async () => {
        const convertedImages = await Promise.all(
            options.map(async (option) => {
                // console.log('option', option);
                const mimeString = option.value.split(".")[1];
                // console.log('mimeString', mimeString);
                const arrayBuffer = new Uint8Array(option.blobValue.length);
                for (let i = 0; i < option.blobValue.length; i++) {
                    arrayBuffer[i] = option.blobValue.charCodeAt(i);
                }
                const blob = new Blob([arrayBuffer], { type: mimeString });
                const file = new File([blob], option.value, { type: mimeString });
                const blobUrl = `data:${mimeString};base64,${option.blobValue}`;

                const defaultValue = fieldState?.result?.find(img => img.value === option.value);
                return {
                    id: `${file.name}-${Date.now()}`,
                    name: file.name,
                    url: blobUrl,
                    default: defaultValue?.default ?? false,
                };
            })
        );
        setImages(convertedImages);
    };

    useEffect(() => {
        if (options?.length > 0) {
            convertOptions();
            console.log('!fieldState', fieldState);
            setHidden(true);
        }
    }, [options]);



    return (
        <Paper elevation={3} sx={{ padding: 2, mt: 3 }}>
            {!hidden && images.length > 0 && <h3 style={{ marginTop: 0 }}>Options Editor</h3>}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, flexDirection: "column" }}>
                {images.map((image) => (
                    <div
                        style={{ display: "flex", justifyContent: "space-between" }}
                        key={image.id}
                    >
                        <FormControlLabel
                            control={
                                multiple ? (
                                    <Checkbox
                                        checked={image.default}
                                        onChange={() => handleSelectionChange(image)}
                                    />
                                ) : (
                                    <Radio
                                        checked={image.default}
                                        onChange={() => handleSelectionChange(image)}
                                    />
                                )
                            }
                            label={
                                <img
                                    src={image.url}
                                    alt={image.name}
                                    style={{ width: 100, height: 100, objectFit: "cover" }}
                                />
                            }
                        />
                        {!hidden && (
                            <div style={{ flexBasis: 80 }}>
                                <IconButton onClick={(e) => console.log("attr")}>
                                    <ModeEdit />
                                </IconButton>
                                <IconButton onClick={() => handleRemoveImage(image.id)}>
                                    <Delete />
                                </IconButton>
                            </div>
                        )}
                    </div>
                ))}
            </Box>
            {!hidden && (
                <Button variant="contained" component="label" sx={{ marginTop: 5 }}>
                    Add Images
                    <input
                        hidden
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleImageUpload}
                    />
                </Button>
            )}
        </Paper>
    );
};

export default ImageSelector;
